


























import { TTabsItem } from '@/api/schema';
import VTabsHash from '@/components/VTabsHash.vue';
import { mapGetters, mapState } from 'vuex';
import { ECopyStakeFeatureFlag } from '@/store/modules/feature-flags/FeatureFlagNames';

export enum EAutoclickerTabsKeys {
  AUTOCLICKER = 'autoclicker',
  AI_STREAMERS = 'ai_streamers',
  WEB_AI_STREAMER_PROFILES = 'web_ai_streamer_profiles',
  GAMES_FOR_AUTOCLICKER = 'games-for-autoclicker',
  JOB_MANAGEMENT = 'job-management'
}

export default {
  name: 'CopyStakeAiStreamerTabsView',
  components: {
    VTabsHash,
    CopyStakeAutoclickerTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/AiStreamers/CopyStakeAutoclickerTab.vue'
      ),
    CopyStakeAiStreamersTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/AiStreamers/CopyStakeAiStreamersTab.vue'
      ),
    CopyStakeWebAiStreamerProfilesTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/WebAiStreamerProfiles/CopyStakeWebAiStreamerProfilesTab.vue'
      ),
    CopyStakeGamesForAutoclickerTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/GamesForAutoclicker/CopyStakeGamesForAutoclickerTab.vue'
      ),
    CopyStakeJobManagementTab: (): any =>
      import(
        '@/views/CopyStake/CopyStakeAutoclicker/JobManagement/CopyStakeJobManagementTab.vue'
      )
  },
  data(): any {
    return {
      currentTab: 0
    };
  },
  computed: {
    ...mapState('app', ['isSuperAdmin']),
    ...mapGetters('FeatureFlags', [
      'isEnabledFeatureFlag',
      'isFeaturesLoading'
    ]),

    isNewFlow(): boolean {
      return this.isEnabledFeatureFlag(
        ECopyStakeFeatureFlag.AUTOCLICKER_FLOW_V2
      );
    },
    tabs(): TTabsItem[] {
      if (this.isFeaturesLoading) return [];

      return [
        ...(this.isNewFlow
          ? [
              {
                id: EAutoclickerTabsKeys.AI_STREAMERS,
                text: 'AI Streamers',
                component: 'CopyStakeAiStreamersTab',
                visible: true
              },
              {
                id: EAutoclickerTabsKeys.WEB_AI_STREAMER_PROFILES,
                text: 'Streamer Profiles',
                component: 'CopyStakeWebAiStreamerProfilesTab',
                visible: true
              }
            ]
          : [
              {
                id: EAutoclickerTabsKeys.AUTOCLICKER,
                text: 'Autoclicker',
                component: 'CopyStakeAutoclickerTab',
                visible: true
              }
            ]),
        {
          id: EAutoclickerTabsKeys.GAMES_FOR_AUTOCLICKER,
          text: 'Games for Autoclicker',
          component: 'CopyStakeGamesForAutoclickerTab',
          visible: this.isSuperAdmin
        },
        {
          id: EAutoclickerTabsKeys.JOB_MANAGEMENT,
          text: 'Job Management',
          component: 'CopyStakeJobManagementTab',
          visible: true
        }
      ].filter(({ visible }) => visible);
    }
  }
};
